import { Link } from 'react-router-dom';

// icons
import { faFileCheck } from '@fortawesome/pro-regular-svg-icons';
import { Grid, useTheme } from '@mui/material';

// components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useActor } from '../../../../components/hooks/useActor';
import { SolidButton, StyledHeader, StyledParagraph } from './styles';

export const AttestQuote = ({ policy, canUserAttest = true }: any) => {
  const actor = useActor();
  const theme = useTheme();

  let availableUrl = `/customer/quotes/${policy.quoteId}/attest/${policy.product}`;

  if (policy.customerEmail !== actor.email) {
    availableUrl = `/customer/quotes/${policy.quoteId}/insuredName/${policy.product}`;
  }

  if (!canUserAttest) {
    return (
      <Grid container columnSpacing={2} rowSpacing={2}>
        <Grid
          item
          md={3}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <FontAwesomeIcon
            icon={faFileCheck}
            size="4x"
            color={theme.palette.common.gunmetalBlue}
          />
        </Grid>
        <Grid item md={9}>
          <StyledHeader>Attest</StyledHeader>
          <StyledParagraph>
            Quote has subjectivities that must be completed. Please contact your
            agent for more information.
          </StyledParagraph>
          <SolidButton
            type="submit"
            sx={{ marginTop: '1rem', width: '100% !important' }}
            disabled
          >
            Attest
          </SolidButton>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container columnSpacing={2} rowSpacing={2}>
      <Grid
        item
        md={3}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <FontAwesomeIcon
          icon={faFileCheck}
          size="4x"
          color={theme.palette.common.gunmetalBlue}
          style={{ marginLeft: '1rem' }}
        />
      </Grid>
      <Grid item md={9}>
        <StyledHeader>Attest</StyledHeader>
        <StyledParagraph>
          Quote has been approved by your agent and is ready for attestion
        </StyledParagraph>
        <Link style={{ display: 'block' }} to={availableUrl}>
          <SolidButton type="submit" sx={{ marginTop: '1rem' }}>
            Attest
          </SolidButton>
        </Link>
      </Grid>
    </Grid>
  );
};
